var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-group"},[_c('img',{attrs:{"src":require("@/assets/imags/logo.png"),"alt":"资阳市博物馆"}})])
}]

export { render, staticRenderFns }